// @flow

// web_closeup_immersive experiment groups
export const EMPLOYEES = 'employees';
export const ENABLED_HOLDOUT = 'enabled_holdout';
export const ENABLED_ICON = 'enabled_icon';
export const ENABLED_NUX = 'enabled_nux';
export const ENABLED_PRODUCT_FIX = 'enabled_product_fix';
export const ENABLED_PRODUCT_FIX_HOLDOUT = 'enabled_product_fix_holdout';
export const ENABLED_UNDERLINE = 'enabled_underline';
export const ENABLED_UPDATES = 'enabled_updates';
export const LEGO_UPDATES_GROUPS = [
  EMPLOYEES,
  ENABLED_HOLDOUT,
  ENABLED_NUX,
  ENABLED_PRODUCT_FIX,
  ENABLED_PRODUCT_FIX_HOLDOUT,
  ENABLED_UPDATES,
];

// web_closeup_immersive specific widths
export const LEGO_MAX_WIDTH = 1016;
export const LEGO_PANE_WIDTH = 508;
export const LEGO_IMAGE_PADDING = 40; // Total padding around image- 2 * 20px

export const CLOSEUP_ACTION_BAR_HEIGHT = 72;

// web_closeup_wide_video specific widths
export const WIDE_VIDEO_MAX_WIDTH = 740;
export const WIDE_VIDEO_MIN_WIDTH = 542;

// Schema.org schema definition urls
export const ITEM_TYPES = {
  ARTICLE: 'https://schema.org/Article',
  BRAND: 'https://schema.org/Brand',
  PRODUCT: 'https://schema.org/Product',
  RECIPE: 'https://schema.org/Recipe',
  OFFER: 'https://schema.org/Offer',
  OUT_OF_STOCK: 'https://schema.org/OutOfStock',
  PERSON: 'https://schema.org/Person',
};
